import React from 'react';
import { withTranslation } from 'react-i18next';
import { GoalLine } from './GoalLine';
import { LEVEL_ORDER, LEVEL_BORDER_CLASS, levelLabelKey } from './goalFormatters';

function GoalDrawerComponent({ goalsByLevel, t }) {
    const visibleLevels = LEVEL_ORDER.filter(l => goalsByLevel[l] && goalsByLevel[l].length > 0);
    if (visibleLevels.length === 0) return null;

    return (
        <div className="goal-drawer">
            <div className="row g-3">
                {visibleLevels.map(level => {
                    const entries = goalsByLevel[level];
                    const titleKey = levelLabelKey(level);
                    return (
                        <div key={level} className="col-12 col-md-6 col-xl-4">
                            <div className={`goal-level-card ${LEVEL_BORDER_CLASS[level]}`}>
                                <header className="goal-level-card__header">
                                    <span className="goal-level-card__title">{titleKey ? t(titleKey) : level}</span>
                                    <span className="goal-level-card__count">{entries.length}</span>
                                </header>
                                <ul className="goal-level-card__list">
                                    {entries.map(goal => (
                                        <li key={`${goal.level}-${goal.item_id}-${goal.priority}`}>
                                            <GoalLine goal={goal} />
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export const GoalDrawer = withTranslation()(GoalDrawerComponent);
